import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { strings } from '../../../localization/strings'
import Loader from '../../loaders'
import { makeStyles, Typography, Dialog, DialogTitle, DialogContent, Checkbox, Button } from '@material-ui/core'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { getNews, setNewAsRead } from '../../../helpers/restHelpers'
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import { logOutAction } from '../../../actions/usersActions'
import { cleanStatusAction } from '../../../actions/appActions'


const useStyles = makeStyles({
    alertContainer: {
        backgroundColor: '#b6780e',
    },
    alert: {
        textAlign: 'center',
    },
    onlyImage: {
        '& p': {
            margin: 0
        }
    },
    alertContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '& img': {
            objectFit: 'contain',
            maxHeight: '95vh',
            maxWidth: '90vw'
        }
    },
    alertTitle: {
        backgroundColor: '#f7b500',
        color: '#fff',
        textAlign: 'center',
        height: '150px',
        fontSize: '50px',
    },
    alertText: {
        width: '70%',
        margin: '50px auto',
    },
    alertIcon: {
        fontSize: '80px',
    },
    agree: {
        display: 'flex',
        alignItems: 'center',
        padding: '5px',
        '& p': {
            fontSize: '16px',
        },
    },
    agreeBtn: {
        margin: '20px auto',
    },
    imagePaperStyles: {
        margin: '10px',
        maxWidth: '99vh',
        width: 'auto',
        maxHeight: '99vh',
        height: 'auto'
    },
    newsContent: {
        '& tbody tr': {
            border: 'none !important',
        },
        '& table': {
            borderCollapse: 'collapse',
        },
    }
})

const RestrictiveNew = (props) => {
    const styles = useStyles()

    const [isOnlyImage, setIsOnlyImage] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [checked, setChecked] = useState(false);
    const [restrictiveNew, setRestrictiveNew] = useState();
    const [redirect, setRedirect] = useState(false)

    const getAllNews = async () => {
        const response = await getNews()
        const restrictive = response.find((oneNew) => oneNew.type === 2 && !oneNew.read)
        if (response && restrictive) {
            setRestrictiveNew(restrictive)
            const text = restrictive.text
            setIsOnlyImage(text.includes('src="data:image') && text.trim().split(" ").length == 2)
        } else if (response && !restrictive) {
            setRedirect(true)
        }
        setIsLoading(false)
    }

    const handleAgree = async () => {
        setIsLoading(true)
        await setNewAsRead(restrictiveNew.id)
        props.history.push('/orders')
    }

    const handleCheck = (e) => {
        setChecked(e.target.checked);
    }
    useEffect(() => {
        getAllNews();
    }, []);

    if (isLoading) return <Loader />;

    const showHeader = !(isOnlyImage || restrictiveNew.text.startsWith("<!--SHOW_HEADER:false-->"));
    
    return (
        <>
            {restrictiveNew ? (
                <Dialog
                    className={styles.alertContainer}
                    open={true}
                    maxWidth={'xl'}
                    fullWidth={true}
                    PaperProps={{
                        className: isOnlyImage ? styles.imagePaperStyles : null
                    }}
                >
                    {!showHeader ? null :
                        <DialogTitle className={styles.alertTitle} disableTypography>
                            <ErrorOutlineIcon className={styles.alertIcon} /><br />
                            {strings.restrictiveNew.atention}
                        </DialogTitle>
                    }
                    <DialogContent dividers={false} className={styles.alert} >
                        <div id="scroll-dialog-description" className={styles.alertContent}>
                            <div id='alertText' dangerouslySetInnerHTML={{ __html: restrictiveNew.text }} className={`${isOnlyImage ? styles.onlyImage : styles.alertText} ${styles.newsContent}`} >
                            </div>
                            <div className={styles.agreeContainer}>
                                {isOnlyImage ? null :
                                    <div className={styles.agree}>
                                        <Checkbox
                                            checked={checked}
                                            onChange={handleCheck}
                                            className={styles.checkbox}
                                            color='default'
                                        />
                                        <Typography>{strings.restrictiveNew.agree}</Typography>
                                    </div>
                                }
                                <Button
                                    onClick={handleAgree}
                                    variant="contained"
                                    disabled={isOnlyImage ? false : !isOnlyImage && !checked ? true : false}
                                    color="primary"
                                    className={styles.agreeBtn}
                                >
                                    {strings.restrictiveNew.closeBtn}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            )
                : redirect ?
                    (<Redirect to='/orders' />)
                    : null}
        </>
    )
}

const mapStateToProps = (store) => ({})
const mapDispatchToProps = { logOutAction, cleanStatusAction }
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RestrictiveNew))